<template>
	<div class="row justify-content-center">
		<div class="col-lg-10 mt-5">

			<form @submit.prevent="submitForm">
				<div class="row justify-content-center">
					<div class="col-12 text-center">
						<h1 class="fs-1-5">In quest’area puoi caricare una story per la classe {{className}}</h1>
					</div>
					<div class="col-xl-10">
						<hr class="fv-hr my-4">
					</div>
				</div>
				<input type="hidden" value="" v-model="form.prevVimeoCode">
				<div class="row align-items-center justify-content-center">
					<div class="col-12 text-center mb-3">
						<h2>1. Dai un titolo alla Story*</h2>
					</div>
					<div class="col-lg-10 col-xl-8 form-group mb-2">
						<input type="text" name="title" id="title" class="form-control form-control-lg" placeholder="Scrivi qui il titolo*" required autocomplete="aut_off_iuasdsvkz" maxlength="80" v-model="form.title">
					</div>
					<div class="col-12 text-right"><small>Max 80 caratteri</small></div>

					<div class="col-12 text-center mb-2 mt-5">
						<h2>2. Carica il video in formato verticale*</h2>
						<p>
						Ti consigliamo di creare un video molto breve e che non superi i 90-120 secondi.
						Saranno accettati video registrati in formato verticale (9:16), con estensione MOV, MPEG4, AVI, WNV, FLV e del peso massimo di 50 MB.
						Cliccando su 'Sfoglia' potrai accedere alla tua library, selezionare il file e caricarlo.
						Il caricamento del video potrebbe richiedere qualche istante. Dovrai accettare la liberatoria per poter caricare il video.
						</p>
					</div>
					<div class="col-12 form-group mb-2 mt-1 text-center">
						<label for="file-upload" class="custom-file-upload fs-1-1 bold rounded-pill" role="button">
							<span class="va-baseline">Scegli file</span> <i class="far fa-play-circle fs-2 va-sub ml-1"></i>
						</label>
						<input id="file-upload" type="file" ref="file" @change="processFile($event)" />
					</div>

					<div class="col-12 text-center" v-if="msgFile">
						<div class="msg_file bold" v-html="msgFile"></div>
					</div>

					<div class="col-7 col-sm-5 col-md-4 col-xl-3" v-if="embedCodeHtml && urlPreview">
						<div class="preview-container-video">
							<video width="1080" controls>
								<source :src="urlPreview" type="video/mp4">
								Your browser does not support the video tag.
							</video>
						</div>
					</div>
					<div class="col-12"></div>
					<div class="col-12 text-center mb-2 mt-5">
						<h2>3. Carica le liberatorie*</h2>
						<p>
							Per caricare una Story è necessario dichiarare di essere in possesso dell’autorizzazione alla partecipazione e consenso al trattamento dei dati
							dei ragazzi visibili nel video. Raccogli tutte le autorizzazioni debitamente compilate dai <span class="bold">titolari della responsabilità genitoriale</span>
							(la <a :href="urlTheme + '/pdf/doc/liberatoria_minore.pdf'" target="_blank">liberatoria</a> è fornita nell’area riservata), scansionale o fotografale e caricale qui con un unico file .zip (peso massimo consentito 15MB).
						</p>
					</div>
					<div class="col-lg-7 mt-3">
						<div class="row">
							<div class="col-1 form-group custom-form-check mt-2 mb-3 pr-0 text-center">
								<input id="prvc_liberatoria" class="checkbox-custom black" name="prvc_liberatoria" type="checkbox" v-model="form.liberatoria">
								<label for="prvc_liberatoria" class="checkbox-custom-label black fs-0-7 text-center"></label>

							</div>
							<div class="col-11 mb-4 mt-2 pl-2 text-left">
								<span class="fs-0-8">
									* Confermo di aver consegnato la informativa privacy, insieme ai moduli di [consenso privacy e liberatoria],
									agli studenti e agli esercenti la potestà genitoriale su di loro, laddove vi siano studenti minorenni
									che risultano riconoscibili nel materiale video di cui si procede al caricamento e allego copia completata
									del consenso privacy e della liberatoria. Sono consapevole che, laddove le informazioni rilasciate risultassero non veritiere
									o non fossero completate adeguatamente, non sarà possibile che il video prenda parte al contest "Fumo e altre Stories"
								</span>
							</div>
						</div>
					</div>
					<div class="col-12 form-group mb-2 mt-1 text-center">
						<label for="file-liberatoria-upload" class="custom-file-upload fs-1-1 bold rounded-pill py-2" role="button">
							<span class="va-baseline">Carica file .zip liberatorie</span> <i class="fas fa-upload fs-1-3 ml-2"></i>
						</label>
						<input id="file-liberatoria-upload" type="file" ref="file-liberatoria" @change="processFileLiberatoria($event)" accept="application/zip" />
					</div>

					<div class="col-12 text-center" v-if="msgFileLiberatoria">
						<div class="msg_file bold" v-html="msgFileLiberatoria"></div>
					</div>

					<div class="col-12 text-center mt-2">
						<div class="fs-1-2 bold" v-html="formMsg"></div>
					</div>

					<div class="col-12 text-center mt-3 mb-3" v-if="btnText">
						<button type="submit" id="sub-work" class="btn btn-blk rounded-pill btn-lg px-5 py-3 va-m" value="INVIA" :disabled="isDisabled"><span>{{btnText}}</span> <i class="fas fa-cog fs-1-5 fa-spin ml-2 mt-1" :class="{'d-none': loaderIsHidden}"></i></button>
					</div>
				</div>
			</form>

			<div class="row">
				<div class="col-12 mt-5 mb-4 text-center text-lg-left">
					<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-arrow-left-square cursor-p" viewBox="0 0 16 16" @click.prevent="closeForm" style="cursor:pointer;">
						<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm11.5 5.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
					</svg>
					<span class="ml-2 bold">Torna indietro</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const jQuery = window.jQuery
import axios from 'axios'

export default {
	name: 'WorkFormComponent',
	props: ['idClass', 'idWork', 'className', 'urlTheme'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			form: {
				title: '',
				videofile: '',
				prevVimeoCode: '',
				prevIdWork: 0,
				idWork: 0,
				liberatoria: '',
				fileLiberatoria: '',
				prevFileLiberatoria: '',

			},
			btnText: 'CONFERMA E INVIA LA STORY',
			embedCodeHtml: '',
			intervalTimer: '',
			formMsg: '',
			msgFile: '',
			msgFileLiberatoria: '',
			loaderIsHidden: true,
			isDisabled: false,
			urlPreview: ''
		}
	},

	methods: {
		closeForm() {
			this.$emit('closeWrkForm')
		},

		submitForm() {
			let url = this.ajaxObj.ajax_url

			if((this.form.videofile == null || this.form.videofile == '' || this.form.videofile == undefined) && this.form.prevIdWork == 0) {
				this.formMsg = '<span class="txt-error">Attenzione: selezionare un video da caricare!</span>'
			} else if((this.form.fileLiberatoria === null || this.form.fileLiberatoria === '' || this.form.fileLiberatoria === undefined) && this.form.prevFileLiberatoria == '') {
				this.formMsg = '<span class="txt-error">Attenzione: selezionare un file (.zip) per caricare la/e liberatoria/e!</span>'
			} else if((this.form.fileLiberatoria === null || this.form.fileLiberatoria === '' || this.form.fileLiberatoria === undefined) && this.form.prevFileLiberatoria == '') {
				this.formMsg = '<span class="txt-error">Attenzione: selezionare un file (.zip) per caricare la/e liberatoria/e!</span>'
			} else {
				this.formMsg = ''
				let formData = new FormData();
				formData.append('action', 'nl_upload_work')
				formData.append('_nounce_value', this.ajaxObj._nounce_value)
				formData.append('file', this.form.videofile)
				formData.append('prevIdWork', this.form.prevIdWork)
				formData.append('prevVimeoCode', this.form.prevVimeoCode)
				formData.append('title', this.form.title)
				formData.append('classID', this.idClass)
				formData.append('workID', this.form.idWork)
				formData.append('check_liberatoria', this.form.liberatoria)
				formData.append('fileLiberatoria', this.form.fileLiberatoria)
				formData.append('prevFileLiberatoria', this.form.prevFileLiberatoria)

				this.loaderIsHidden = false
				this.isDisabled = true

				axios.post(url, formData, {
					headers:{
						'Content-Type' : 'multipart/form-data'
					}
				})
					.then((response) => {
						// console.log(response.data)
						this.loaderIsHidden = true
						if(response.data.error == '') {
							this.checkTranscodeInterval(response.data.uri)
							this.checkTranscode(response.data.uri);
							this.formMsg = response.data.msg
							this.form.videofile = ''
							this.form.fileLiberatoria = ''
							this.msgFile = 'L\'anteprima sarà disponibile a breve...'
							this.form.prevIdWork = response.data.id_work
							this.form.prevVimeoCode = response.data.uri
							this.form.idWork = response.data.id_work
							this.btnText = this.form.idWork > 0 ? 'MODIFICA' : 'INVIA'
							this.msgFileLiberatoria = response.data.file_liberatoria
							this.form.prevFileLiberatoria = response.data.file_liberatoria
						} else {
							this.formMsg = '<span class="txt-error">' + response.data.error + '</span>'
							this.isDisabled = false
						}

					}, (error) => {
						this.isDisabled = false
						this.loaderIsHidden = true
						console.log(error);
					});
			}
		},
		processFile(event) {
			this.urlPreview = ''
			this.form.videofile = event.target.files[0]
			this.msgFile = 'File selezionato: ' + this.form.videofile.name
		},

		processFileLiberatoria(event) {
			this.form.fileLiberatoria = event.target.files[0]
			this.msgFileLiberatoria = 'File selezionato: ' + this.form.fileLiberatoria.name
		},

		checkTranscode(uri) {
			let self = this

			let formData = new FormData()
			formData.append('video_uri', uri)
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('action', 'nl_check_transcode')
			formData.append('classID', this.idClass)
			formData.append('workID', this.form.idWork)

			axios.post( this.ajaxObj.ajax_url,
				formData
			)
			.then(function(response){
				// console.log(response.data)
				if(response.data.status.body.transcode.status == 'complete' &&  response.data.files[0]) {
					self.msgFile = ''
					self.embedCodeHtml = response.data.embed
					self.urlPreview = response.data.files[0].link
					clearInterval(self.intervalTimer)
					self.isDisabled = false
				}
			})
			.catch(function(error) {
				console.log(error)
			});
		},
		checkTranscodeInterval(uri) {
			let self = this
			self.intervalTimer = setInterval(function(){
				self.checkTranscode(uri)
			} ,10000)
		},

		getPreviousStoryData() {
			let self = this
			if(this.form.idWork != 0 && this.form.idWork != '') {
				let formData = new FormData()
				formData.append('_nounce_value', this.ajaxObj._nounce_value)
				formData.append('action', 'nl_get_previous_story_data')
				formData.append('workID', this.form.idWork)
				formData.append('classID', this.idClass)

				axios.post( this.ajaxObj.ajax_url,
					formData
				)
				.then(function(response){
					// console.log(response.data)
					self.form.prevVimeoCode = response.data.db.video_uri
					self.form.title = response.data.db.title
					self.form.prevIdWork = response.data.db.id
					self.form.prevFileLiberatoria = response.data.db.file_liberatorie
					self.msgFileLiberatoria = response.data.db.file_liberatorie
					self.form.liberatoria = response.data.db.check_liberatorie

					if(response.data.db.active == 0) {
						self.btnText = 'MODIFICA'
					} else {
						self.btnText = ''
					}
				})
				.catch(function(error) {
					console.log(error)
				});
			}
		}
	},

	mounted() {
		jQuery(window).scrollTop(0);
		jQuery('.form-work-open').addClass('d-none')
		/*jQuery('#intro-text').addClass('d-none')
		jQuery('#intro-text-1').addClass('d-none')
		jQuery('#school-message').addClass('d-none')
		jQuery('#welcome-text').text('È il momento di caricare la story')
		jQuery('#download_area_privata').addClass('d-none')*/
		this.form.idWork = this.idWork

		if(this.idWork != "0") {
			this.checkTranscode('')
			this.getPreviousStoryData()
		}
	}
}
</script>

<style scoped>
	.fas.fa-cog {
		vertical-align: text-bottom;
		opacity: .9;
	}
	.cursor-p {
		cursor: pointer;
		transition: all .2s ease-in-out;
	}
	.cursor-p:hover, .cursor-p:focus {
		color: #999;
	}
	.checkbox-custom+.checkbox-custom-label:before {
		margin-right: 0;
	}
</style>
